import { configureStore } from "@reduxjs/toolkit";
import dataApi from "api";
import authReducer from "slices/auth";
import practiceReducer from "slices/practice";
import registrationReducer from "slices/registration";
import bookingReducer from "slices/booking";
import prescriptionReducer from "slices/prescription";
import messagesReducer from "slices/messages";

import { messagesMiddleware } from "middlewares/messages";

const appReducers = {
  auth: authReducer,
  practice: practiceReducer,
  registration: registrationReducer,
  bookingFlow: bookingReducer,
  prescription: prescriptionReducer,
  messages: messagesReducer,
};

export const createStore = (middleware: any = null) =>
  configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware()
        .concat(middleware ?? [])
        .concat(messagesMiddleware),
    reducer: {
      ...appReducers,
      [dataApi.reducerPath]: dataApi.reducer,
    },
  });

export const store = createStore(dataApi.middleware);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
